import React from 'react';
import classnames from 'classnames';

import UItem from '../item';
import { clearObj } from '../../utils/tools';
import Select, { SelectProps } from './select';

// 表单 输入框组件
function USelect(props: SelectProps) {
  const {
    value,
    defaultValue,
    placeholder,
    readOnly,
    readonly,
    _crengine = {},
    prefixCls = 'crm-select',
    valueMember = 'value',
    paramType,
    options,
    className,
    reset,
    ...rest
  } = props;

  // 子项内容改变的时候进行数据更新
  function onValueChange(selected: any) {
    const { onChange, ...otherProps } = props;

    if (onChange) {
      onChange({
        ...otherProps,
        value: selected,
      });
    }

    if (
      _crengine
      && _crengine.form
      && reset
      && Array.isArray(reset)
      && reset.length
    ) {
      reset.forEach((resetItem) => {
        _crengine.form.setFieldsValue({
          [`${resetItem}`]: '',
        });
      });
    }
  }

  const selectProps = clearObj({
    prefixCls,
    value,
    defaultValue,
    placeholder,
    className: prefixCls,
    dataSource: options,
    valueMember,
    paramType,
    readOnly: readOnly || readonly,
    onChange: onValueChange,
  });

  const { form } = _crengine || {};

  // 如果wform存在 则去除input组件的某些属性
  if (form) {
    delete selectProps.value;
    delete selectProps.defaultValue;
    delete selectProps.onChange;
  }

  const cls = classnames(prefixCls, className);
  return (
    <UItem
      {...rest}
      itemType="select"
      _crengine={_crengine}
      initialValue={value || defaultValue}
      onChange={(e) => onValueChange(e)}
    >
      <Select className={cls} {...selectProps} />
    </UItem>
  );
}

export default USelect;

export const SelectItem = Select;
